import React from 'react';
import { Paper, Typography, Stack, Link, alpha, useTheme } from '@mui/material';
import { PROFILE_COMPLETION_MESSAGE, PROFILE_LINK_TEXT } from '@/features/opportunities/utils.ts';
import { useGetMe } from '@/lib/api/me.ts';

interface InterestProcessInfoProps {
  onClose?: () => void;
}

export const InterestProcessInfo: React.FC<InterestProcessInfoProps> = ({ onClose }) => {
  const theme = useTheme();
  const { data: user } = useGetMe();

  const handleProfileLinkClick = () => {
    window.open('/perfil?tab=personal', '_blank');
    onClose?.();
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        bgcolor: 'background.default',
        borderRadius: 2,
      }}
    >
      <Stack spacing={1.5}>
        <Typography variant="subtitle2" fontWeight={600}>
          ¿Qué ocurrirá después?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          El PSI recibirá tu solicitud y revisará tu perfil de inversor. Si eres seleccionado, el
          PSI te contactará para aclarar cualquier duda y antes de avanzar en el proceso de reserva.
        </Typography>

        {user && !user.profileCompleted && (
          <Paper
            elevation={0}
            sx={{
              p: 1.5,
              bgcolor: alpha(theme.palette.info.main, 0.08),
              border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
              borderRadius: 1,
            }}
          >
            <Typography variant="body2" color="info.main" fontWeight={400}>
              {PROFILE_COMPLETION_MESSAGE}{' '}
              <Link
                component="button"
                variant="body2"
                onClick={handleProfileLinkClick}
                sx={{
                  color: 'info.main',
                  fontWeight: 700,
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                {PROFILE_LINK_TEXT}
              </Link>
              .
            </Typography>
          </Paper>
        )}
      </Stack>
    </Paper>
  );
};
